







































import { Component, Vue } from 'vue-property-decorator';
import { NewsModule } from '@/store/modules/news/news.store';
import { UserModule } from '@/store/modules/user/user.store';

import TextEditor from '@/plugins/text-editor/TextEditor.vue';
import NewsArticle from '@/components/frontpage/news/NewsArticle.vue';
import { ApiPermissions } from '@/core/security/Permissions';
import { NewsViewObject } from '@/types/apiServerContract';

@Component({
    components: {
        TextEditor,
        NewsArticle
    }
})
export default class CreateNews extends Vue {
	permissions: string[] = [ApiPermissions.News.CreateNews];
	news: NewsViewObject = {
	    commentCount: 0,
	    comments: [],
	    content: '',
	    date: new Date(),
	    id: 0,
	    reactions: [],
	    title: '',
	    author: '',
	    authorEmail: '',
	    authorName: '',
	    emailHidden: false
	};

	loading: boolean = false;

	mounted() {
	    this.news.authorName = UserModule.user!.userName;
	}

	async CreateNews() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure this news is ready for submitting?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.news.author = UserModule.user!.id;

	    try {
	        this.loading = true;
	        await NewsModule.CreateNews({ title: this.news.title, content: this.news.content });
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('News added successfully', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.Reset();
	    this.$nextTick(() => {
	        (this.$refs.AddNews as any).reset();
	    });
	}

	Reset() {
	    this.news = {
	        commentCount: 0,
	        comments: [],
	        content: '',
	        date: new Date(),
	        id: 0,
	        reactions: [],
	        title: '',
	        author: '',
	        authorEmail: '',
	        authorName: '',
	        emailHidden: false
	    };
	}
}
